import { render, staticRenderFns } from "./AgentProd.vue?vue&type=template&id=c08006ba&"
import script from "./AgentProd.vue?vue&type=script&lang=js&"
export * from "./AgentProd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports